<!-- auth-page wrapper -->
<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
    <!-- auth-page content -->
    <div class="auth-page-content overflow-hidden pt-lg-5">
        <div class="container">
            <div class="row">
                <div class="card mx-auto col-lg-6 rounded-4">
                    <div class="p-lg-5 p-4">
                        <h4>Create new password</h4>
                        <p class="fw-light text-muted">Your new password must be different from previous one.</p>

                        <div class="p-2">
                            <form [formGroup]="passcreateForm" (ngSubmit)="onSubmit()">
                                <div class="mb-3">
                                    <label class="form-label" for="current-password-input">Current Password <span
                                            class="text-danger">*</span></label>
                                    <div class="position-relative auth-pass-inputgroup mb-3">
                                        <input [type]="currentField ? 'text' : 'password'"
                                            class="form-control pe-5 password-input"
                                            placeholder="Enter current password" id="current-password-input" required
                                            formControlName="currentpassword" 
                                            [ngClass]="{ 'is-invalid': submitted && f['currentpassword'].errors }">
                                        <button
                                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                            type="button" id="current-password-input"><i class="mdi align-middle"
                                                [ngClass]="{'mdi-eye-outline': !currentField, 'mdi-eye-off-outline': currentField
                                        }" (click)="togglecurrentField()"></i></button>
                                        @if(submitted && f['currentpassword'].errors){
                                        <div class="invalid-feedback">
                                            @if(f['currentpassword'].errors['required']){
                                            <span>{{errormsgs.REQUIRED_VALIDATION}}</span>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label" for="password-input">New Password <span
                                            class="text-danger">*</span></label>
                                    <div class="position-relative auth-pass-inputgroup">
                                        <input [type]="passwordField ? 'text' : 'password'"
                                            class="form-control pe-5 password-input" placeholder="Enter password"
                                            id="password-input" aria-describedby="passwordInput"
                                            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required
                                            formControlName="password" 
                                            [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">
                                        <button
                                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                            type="button" id="password-addon"><i class="mdi align-middle" [ngClass]="{'mdi-eye-outline': !passwordField, 'mdi-eye-off-outline': passwordField
                                        }" (click)="togglepasswordField()"></i></button>
                                        @if(submitted && f['password'].errors){
                                        <div class="invalid-feedback">
                                            @if(f['password'].errors['required']){
                                            <span>{{errormsgs.REQUIRED_VALIDATION}}</span>
                                            }@else if(f['password'].errors['pattern']){
                                            <span>{{errormsgs.PASSWORD_VALIDATION}}</span>
                                            }
                                        </div>}
                                    </div>
                                    <div id="passwordInput" class="form-text">Must be at least 8 characters.</div>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label" for="confirm-password-input">Confirm Password <span
                                            class="text-danger">*</span></label>
                                    <div class="position-relative auth-pass-inputgroup mb-3">
                                        <input [type]="confirmField ? 'text' : 'password'"
                                            class="form-control pe-5 password-input" placeholder="Confirm password"
                                            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" id="confirm-password-input"
                                            required formControlName="cpassword" 
                                            [ngClass]="{ 'is-invalid': submitted && f['cpassword'].errors }">
                                        <button
                                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                            type="button" id="confirm-password-input"><i class="mdi align-middle"
                                                [ngClass]="{'mdi-eye-outline': !confirmField, 'mdi-eye-off-outline': confirmField
                                        }" (click)="toggleconfirmField()"></i></button>
                                        @if(submitted && f['cpassword'].errors){
                                        <div class="invalid-feedback">
                                            @if(f['cpassword'].errors['required']){
                                            <span>{{errormsgs.REQUIRED_VALIDATION}}</span>
                                            }@else if(f['cpassword'].errors['pattern']){
                                            <span>{{errormsgs.PASSWORD_VALIDATION}}</span>
                                            }@else if(f['cpassword'].errors['confirmedValidator']){
                                            <span>{{errormsgs.PASSWORD_MATCH_VALIDATION}}</span>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div id="password-contain" class="p-3 bg-body mb-2 rounded">
                                    <h5 class="fs-13">Password must contain:</h5>
                                    <p id="pass-length" class="invalid fs-12 mb-2">Minimum <b>8 characters</b></p>
                                    <p id="pass-lower" class="invalid fs-12 mb-2">At <b>lowercase</b> letter (a-z)</p>
                                    <p id="pass-upper" class="invalid fs-12 mb-2">At least <b>uppercase</b> letter (A-Z)
                                    </p>
                                    <p id="pass-number" class="invalid fs-12 mb-0">A least <b>number</b> (0-9)</p>
                                </div>

                                <div class="mt-4 d-flex justify-content-end align-items-center">
                                    <a routerLink="/" class="fw-semibold text-muted text-decoration-underline me-3">Skip
                                        for now</a>
                                    @if(isloading){
                                    <button class="btn btn-primary right" type="submit"><span
                                            class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                                        <span role="status"> Loading...</span></button>
                                    }
                                    @else{
                                    <button type="submit" class="btn btn-primary btn-label right"><i
                                            class="mdi mdi-arrow-right-bold label-icon align-middle fs-16 ms-2"></i>
                                        Reset Password</button>
                                    }
                                </div>

                            </form>
                        </div>
                    </div>
                    <!-- end card -->
                </div>
                <!-- end col -->

            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </div>
    <!-- end auth page content -->

    <!-- footer -->
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-center">
                        <p class="mb-0 text-light">{{copyright}}</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- end Footer -->
</div>
<!-- end auth-page-wrapper -->